import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { PickerModule } from '@ctrl/ngx-emoji-mart';

import { AntdModule } from 'src/app/antd.module';

import { TopbarLanguageSwitcherComponent } from './language-switcher/language-switcher.component';
import { TopbarSearchComponent } from './search/search.component';
import { TopbarUserMenuComponent } from './user-menu/user-menu.component';
import { TopbarProjectManagementComponent } from './project-management/project-management.component';
import { TopbarFavPagesComponent } from './fav-pages/fav-pages.component';

import { MenuLeftComponent } from './menu/menu-left/menu-left.component';
import { MenuTopComponent } from './menu/menu-top/menu-top.component';
import { FooterComponent } from './footer/footer.component';
import { BreadcrumbsComponent } from './breadcrumbs/breadcrumbs.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { AppPowerBIReportComponent } from './powerbi-embedded/app-pbi-report.component';

const COMPONENTS = [
  TopbarSearchComponent,
  TopbarUserMenuComponent,
  TopbarProjectManagementComponent,
  TopbarLanguageSwitcherComponent,
  TopbarFavPagesComponent,
  MenuLeftComponent,
  MenuTopComponent,
  FooterComponent,
  BreadcrumbsComponent,
  SidebarComponent,
  AppPowerBIReportComponent,
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    AntdModule,
    TranslateModule,
    NgScrollbarModule,
    FontAwesomeModule,
    NgxDropzoneModule,
    PickerModule,
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
  bootstrap: [],
  schemas: [],
})
export class CustomComponentsModule { }
